import React from 'react';
import './ProductCard.css';

function ProductCard({ product }) {
  const handleViewDetails = () => {
    if (product.url) {
      window.open(product.url, '_blank', 'noopener,noreferrer');
    } else {
      console.log('No URL available for this product');
      // You could add a fallback behavior here, like showing a modal with more details
    }
  };

  return (
    <div className="product-card" onClick={handleViewDetails}>
      <div className="product-image-container">
        <img 
          src={product.image || product.img_url || 'https://via.placeholder.com/150'}
          alt={product.name} 
          className="product-image" 
        />
      </div>
      <div className="product-info">
        <h3 className="product-name">{product.name}</h3>
        <p className="product-price">${product.price}</p>
        <p className="product-store">{product.store}</p>
        <button className="view-button" onClick={(e) => {
          e.stopPropagation(); // Prevent the card click event from firing
          handleViewDetails();
        }}>View Details</button>
      </div>
    </div>
  );
}

export default ProductCard;
